export const ServiceCallApplicationIndexSceneTranslation = {
  fi: {
    ServiceCallApplicationIndexScene: {
      title: 'Huoltokutsuliittymä-hakemukset',
      pendingTitle: 'Odottavat hakemukset',
      approvedTitle: 'Aktiiviset käyttäjät',
      inactiveTitle: 'Ei-aktiiviset käyttäjät',
      rejectedTitle: 'Hylätyt hakemukset',
      approve: 'Hyväksy',
      reject: 'Hylkää',
      revokeAccess: 'Kytke käyttöoikeus pois',
      reactivate: 'Palauta aktiiviseksi',
      approved: 'Hakemus hyväksytty',
      rejected: 'Hakemus hylätty',
      accessRevoked: 'Käyttöoikeus kytketty pois',
      reactivated: 'Käyttöoikeus palautettu',
      confirmApprove: 'Hyväksytäänkö yrityksen {{name}} hakemus?',
      confirmReject: 'Hylätäänkö yrityksen {{name}} hakemus?',
      confirmRevokeAccess: 'Kytketäänkö yrityksen {{name}} käyttöoikeus pois?',
      confirmReactivate: 'Palautetaanko yrityksen {{name}} käyttöoikeus aktiiviseksi?',
      notFound: 'Hakemusta ei löytynyt.',
    },
    ServiceCallApplication: {
      officialName: 'Yritys',
      businessId: 'Y-tunnus',
      contactName: 'Yhteyshenkilö',
      email: 'Sähköposti',
      phone: 'Puhelin',
      status: 'Tila',
      createdAt: 'Vastaanotettu',
      actions: 'Toiminnot',
      streetAddress: 'Katuosoite',
      postalCode: 'Postinumero',
      city: 'Paikkakunta',
      industry: 'Toimiala / kuvaus',
      personnelCount: 'Yrityksen henkilömäärä',
      handledAt: 'Käsitelty',
    },
  },
};
